var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatPanel',_vm._b({staticClass:"pie-chart-stat-panel",style:({ 'min-height': (_vm.loading) ? _vm.minHeightLoading : 'auto' })},'StatPanel',_vm.$props,false),[_c('div',{staticClass:"canvascontainer"},[_c('canvas',{ref:"canvasElement"})])])}
var staticRenderFns = []

export { render, staticRenderFns }